import { ClubListPage } from '@features/club/pages/ClubListPage/ClubListPage';
import { PromoNavigationWidget } from '@features/club/ui/PromoNavigation/PromoNavigationWidget';
import { PromotedClubsWidget } from '@features/club/ui/PromotedClubs/PromotedClubsWidget';
import { ClubsListWidget } from '@features/club/ui/ClubsList/ClubsListWidget';
import { useIsAdmin } from '@features/auth/hooks/useIsAdmin';
import { ClubCreateModalWidget } from '@features/club/ui/ClubCreateModal/ClubCreateModalWidget';
import { ClubCreateFormValues } from '@features/club/ui/ClubCreateForm';
import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';

export type Props = {
  isCreateModalOpen: boolean;
  setIsCreateModalOpen: (isOpen: boolean) => void;
};

export function ClubListPageWidget({
  isCreateModalOpen,
  setIsCreateModalOpen,
}: Props) {

  const isAdmin = useIsAdmin();

  const navigate = useNavigate();
  const onCreateSuccess = useCallback(({ clubId }: ClubCreateFormValues) => {
    navigate({
      from: '/',
      to: '/club/$clubId',
      params: { clubId },
      // to: '/club/$clubId/settings',
      // search: { pageTab: 'admin' },
    });
  }, [navigate]);

  const onCreateCancel = useCallback(() => {
    setIsCreateModalOpen(false);
  }, [setIsCreateModalOpen]);

  return (
    <ClubListPage
      navigation={<PromoNavigationWidget activeTab="clubs" />}
      promotedClubs={<PromotedClubsWidget />}
      allClubsList={<ClubsListWidget />}
      modals={
        <>
          {isCreateModalOpen && (
            <ClubCreateModalWidget
              onCancel={onCreateCancel}
              onClose={onCreateCancel}
              onSubmitSuccess={onCreateSuccess}
            />
          )}
        </>
      }
      onClubCreate={
        isAdmin && !isCreateModalOpen
          ? () => setIsCreateModalOpen(true)
          : undefined
      }
    />
  );
}
